import React, { PropTypes, Component } from 'react';
import { NitroDivider, NitroHeading, NitroParagraph } from 'nitro-components';


import styled from 'styled-components';

const GroupBoxContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

const Group = styled.div`
  text-align: ${props => props.align};
  order: ${props => props.align === 'left' ? '0' : '1'};
`;
// .group-box{
//   .group-container{
//
//   }
//   .divider{
//     padding-top: 12px;
//     margin: 0 0 20px 0;
//   }
// }

class GroupBox extends Component {
  render () {
    const { children } = this.props;
    return (
      <div className="group-box">
        <GroupBoxContainer className="group-container">
          {children.map((child, idx) => {
            return (
              <Group className="group" align={child['@Alignment']} key={idx}>
                <NitroHeading label={child.Header} size="3" variant="secondary" noMargin />
                <NitroParagraph size="4" variant="base3" noMargin>{child.SubHeader}</NitroParagraph>
              </Group>
            );
          })}
        </GroupBoxContainer>
        <NitroDivider noTopPad />
      </div>

    );
  }
}

GroupBox.propTypes = {
  children: PropTypes.array
};

export default GroupBox;



// WEBPACK FOOTER //
// ./src/components/factoryComponents/GroupBox.js